export default __webpack_public_path__ + "static/media/facebook.5773ec52.svg";